module.exports = __webpack_public_path__ + "static/ff-f1558aa8de38a4a5908b038a6620b8db.gif";